<template>
    <div class="form__group">
        <label :for="name" class="form__label">{{ label }}</label>
        <date-picker
            :id="name"
            :name="name"
            type="datetime"
            :format="format"
            value-type="format"
            v-model="selected"
            :default-value="formattedDefaultDate"
            :disabled-date="disableDates"
            input-class="form__control"
            @change="updateNow"
            required
        />
    </div>
</template>

<script>
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import { format } from 'date-fns';

    DatePicker.CalendarPanel.methods.updateNow = function () {
        this.date = new Date();
        this.update();
    };

    export default {
        components: {DatePicker},
        name: "FormControlDatetimePicker",
        props: {
            defaultValue: null,
            label: '',
            name: 'time',
            minDate: null,
            maxDate: null,
        },
        watch: {
            defaultValue: function (newVal, oldVal) {
                if(newVal !== oldVal) {
                    console.log("Default value changed", newVal, oldVal);

                    this.selected = this.formatDate(newVal);
                }
            }
        },
        computed: {
            formattedDefaultDate() {
                if(this.defaultValue) {
                    // YYYY-MM-DD HH:mm:ss
                    return this.formatDate(this.defaultValue);
                }

                return null;
            }
        },
        methods: {
            updateNow(date) {
                console.log("Updating now", date);
                this.$emit('input', date);
            },
            formatDate(date) {
                return format(date, "yyyy-MM-dd HH:mm:ss");
            },
            disableDates(date) {
                if(this.minDate && this.maxDate) {
                    return date < this.minDate || date > this.maxDate;
                }

                return false;
            }
        },
        data() {
            return {
                date: null,
                format: 'YYYY-MM-DD HH:mm:ss',
                value: '',
                selected: this.defaultValue ? this.formatDate(this.defaultValue) : null,
                disabled: false,
                required: false,
                error: null,
            }
        }
    }
</script>

<style scoped lang="scss">

</style>
